<div class="modal-header">
    <h4 class="modal-title">Manage {{ type }} Presets</h4>
</div>
<div class="modal-body">
    <p>Rename or delete presets.</p>
    <table class="table table-hover">
        <tbody>
            <tr *ngFor="let preset of presets">
                <ng-container *ngIf="!preset.IsDeleted">
                    <td>
                        <input
                            legacy-css
                            class="form-control"
                            [(ngModel)]="preset.Description"
                            required
                            maxlength="50"
                            minlength="1"
                            (change)="validate()" />
                    </td>
                    <td class="text-right">
                        <button type="button" class="btn btn-danger btn-xs" (click)="deletePreset(preset)">
                            <i class="ti-trash"></i>
                        </button></td
                ></ng-container>
            </tr>
        </tbody>
    </table>
    <div class="alert alert-danger" *ngIf="error">{{ error }}</div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default btn-o btn-wide" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn-primary btn-o btn-wide" (click)="ok()" [disabled]="error">Save &amp; Close</button>
</div>
